import { create } from 'zustand';
import type { ImportStatusMessage } from '@/api';

interface ImportStatusStore {
  status: ImportStatusMessage | null;
  setStatus: (status: ImportStatusMessage) => void;
  clearStatus: () => void;
}

export const useImportStatusStore = create<ImportStatusStore>()((set) => ({
  status: null,
  setStatus: (status) => set({ status }),
  clearStatus: () => set({ status: null }),
}));
